import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismIcon } from '@mylighthouse/prism-ember';
import EmberTooltip from '@mylighthouse/prism-ember/components/ember-tooltip';
import { DISMISSED_SUGGESTIONS_LOCALSTORAGE_KEY } from 'lumen/utils/constants/pms-mapping-constants';
import { findOptionById } from 'lumen/utils/pms-mapping-utils';

interface SettingsMappingTableCellPmsValueCellPmsValueBenchmarkSignature {
  Args: {
    column: unknown;
    row: unknown;
  };
}

export default class SettingsMappingTableCellPmsValueCellPmsValueBenchmark extends Component<SettingsMappingTableCellPmsValueCellPmsValueBenchmarkSignature> {
  @service declare intl: Services['intl'];

  @service declare localStorage: Services['local-storage'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isDisabled() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this.args.column.disableRowActions || this.args.row.readOnly;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get shouldDisplaySuggestionIcon() {
    let isAlreadyMapped = false;
    // @ts-expect-error: Incorrect type
    const { isRateView } = this.args.column;
    const pmsMappingValue = this.args.row;
    // @ts-expect-error: Incorrect type
    const { suggestedCategoryId, readOnly, pmsValue } = pmsMappingValue;
    const isSuggestion = suggestedCategoryId !== null;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const storedValues = JSON.parse(
      // @ts-expect-error: Incorrect type
      this.localStorage.getItem(DISMISSED_SUGGESTIONS_LOCALSTORAGE_KEY),
    );
    if (storedValues) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      const match = storedValues.filter(
        // @ts-expect-error: Incorrect type
        (itemPmsValue) => itemPmsValue === pmsValue,
      );
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      isAlreadyMapped = match.length > 0;
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return (
      !isAlreadyMapped &&
      isRateView &&
      isSuggestion &&
      !this.isDisabled &&
      !readOnly
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get suggestion() {
    // @ts-expect-error: Incorrect type
    const { suggestedCategoryId } = this.args.row;
    const suggestedCategory = findOptionById(
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      this.args.column.categoryOptions,
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      suggestedCategoryId,
    );
    return this.intl.t('benchmark_insight.pms.mapping.tooltip.suggestion', {
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      suggestion: suggestedCategory.value,
    });
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get tooltipText() {
    // @ts-expect-error: Incorrect type
    const { suggestedCategoryReason } = this.args.row;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { arg } = suggestedCategoryReason;
    return this.intl.t(
      'benchmark_insight.pms.mapping.tooltip.suggested_category',
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      { marketCode: arg },
    );
  }

  @action
  setSuggestedCategory(): void {
    const pmsMappingValue = this.args.row;
    // @ts-expect-error: Incorrect type
    if (pmsMappingValue.categoryId !== null) {
      // @ts-expect-error: Incorrect type
      pmsMappingValue.categoryId = null;
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      this.args.column.onChangeCategory(pmsMappingValue);
    }
  }

  <template>
    {{! template-lint-disable require-presentational-children }}
    <div class="flex justify-between">
      {{! @glint-expect-error: Incorrect type }}
      <span>{{@row.pmsValue}}</span>
      {{#if this.shouldDisplaySuggestionIcon}}
        <div
          data-test-id="cell-pms-value-benchmark-link-button"
          role="button"
          {{on "click" this.setSuggestedCategory}}
        >
          <PrismIcon @name="link" @size="small" />
          <EmberTooltip
            @tooltipClass="prism-tooltip"
            {{! @glint-expect-error: Incorrect type }}
            data-test-id="cell-pms-value-benchmark-link-tooltip"
          >
            <p class="paragraph-200--regular">{{this.tooltipText}}</p>
            <p
              class="paragraph-200--regular benchmark-suggestion"
            >{{this.suggestion}}</p>
          </EmberTooltip>
        </div>
      {{/if}}
    </div>
  </template>
}
